import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { ChevronDown, Globe, Loader2 } from 'lucide-react'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string
  /** Идёт свой прогон перевода — крутилка вместо глобуса. */
  isRunning: boolean
  /** Телефон: только значок, подпись — для скринридера. */
  compact?: boolean
}

/**
 * Кнопка меню языка шапки. `forwardRef` и проброс остальных пропсов — ради
 * `DropdownMenuTrigger asChild`: ему нужны ref и свои обработчики на кнопке,
 * а владельцу меню — ref, чтобы вернуть фокус после диалогов.
 */
export const LangTriggerButton = forwardRef<HTMLButtonElement, Props>(
  ({ label, isRunning, compact = false, ...button }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={compact ? label : undefined}
      className="group inline-flex h-8 shrink-0 items-center gap-2 rounded-full bg-surface px-2.5 text-[13px] font-medium text-foreground transition-colors hover:bg-foreground/5 data-[state=open]:bg-foreground/10"
      {...button}
    >
      {isRunning ? (
        <Loader2
          data-testid="lang-switcher-spinner"
          className="size-3.5 animate-spin text-muted-foreground"
        />
      ) : (
        <Globe className="size-3.5 text-muted-foreground" />
      )}
      {compact ? null : label}
      {compact ? null : (
        <ChevronDown className="size-3.5 shrink-0 opacity-60 transition-transform group-data-[state=open]:rotate-180" />
      )}
    </button>
  ),
)
LangTriggerButton.displayName = 'LangTriggerButton'
